import { motion } from "framer-motion";
import { FaBolt, FaMasksTheater } from "react-icons/fa6";
import { FaMedal } from "react-icons/fa";

type Item = {
  icon: React.ReactNode;
  title: string;
  body: string;
};

const ITEMS: Item[] = [
  {
    icon: <FaBolt />,
    title: "Train",
    body: "30-second shit tests. AI scores you on Frame, Humor, and Flirt. Build your reflexes.",
  },
  {
    icon: <FaMasksTheater />,
    title: "Play",
    body: "Drop into AI scenarios — clubs, dates, exes — and play out the full convo until you close or crash.",
  },
  {
    icon: <FaMedal />,
    title: "Compete",
    body: "Climb the global leaderboard. Earn badges. Bookmark the comebacks that hit.",
  },
];

export const HowItWorks = () => (
  <section className="mt-14">
    <h2 className="font-bangers text-2xl text-center">How it works</h2>
    <p className="text-xs font-mono opacity-60 text-center mt-1 max-w-xs mx-auto leading-snug">
      Reps in 5 minutes a day. Built for the moments you usually freeze.
    </p>
    <div className="mt-5 flex flex-col gap-3">
      {ITEMS.map((item, i) => (
        <motion.div
          key={item.title}
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.3, delay: i * 0.08 }}
          className="rounded-2xl border-1 border-neutral-800 bg-neutral-900/40 p-4 flex items-start gap-4"
        >
          <div className="shrink-0 w-12 h-12 rounded-xl bg-primary/15 border-1 border-primary/40 text-primary text-xl flex items-center justify-center">
            {item.icon}
          </div>
          <div>
            <h3 className="font-bangers text-xl leading-none">{item.title}</h3>
            <p className="text-sm font-mono opacity-70 leading-snug mt-1.5">
              {item.body}
            </p>
          </div>
        </motion.div>
      ))}
    </div>
  </section>
);
